<template>
    <div class="purchasers-update-modal">
        <ModalContainer :title="$t('purchasers.edit_purchaser')" identifier="purchasers-update-modal" :closable="true">
            <Form class="form" @submit="save" :disabled="is_loading_original || is_saving">
                <FormInputText v-model="$v.purchaser.name.$model" identifier="name" :label="$t('purchasers.name')"
                               :disabled="is_loading_original || is_saving" :has-error="$v.purchaser.name.$error">
                    <template v-slot:errors>
                        <p v-if="!$v.purchaser.name.required">
                            {{$t('validation.x_is_required',{x: $t('purchasers.name')})}}
                        </p>
                    </template>
                </FormInputText>

                <FormInputText v-model="$v.purchaser.phone.$model" identifier="phone" :label="$t('purchasers.phone')"
                               :disabled="is_loading_original|| is_saving" :has-error="$v.purchaser.phone.$error">
                    <template v-slot:errors>
                        <p v-if="!$v.purchaser.phone.required">
                            {{$t('validation.x_is_required',{x: $t('purchasers.phone')})}}
                        </p>
                    </template>
                </FormInputText>

                <Button type="submit" className="--primary --small" :class="{spinner: is_saving}">
                    {{$t('save')}}
                </Button>
            </Form>
        </ModalContainer>
    </div>
</template>

<script>
    import _ from 'lodash';
    import ModalContainer from "../modal/ModalContainer";
    import Form from "../form/Form";
    import FormInputText from "../form/FormInputText";
    import FormGroupTwo from "../form/FormGroupTwo";
    import FormInputSelect from "../form/FormInputSelect";
    import {required, email} from 'vuelidate/lib/validators'
    import Button from "../Button";
    import FormInputPassword from "@/components/form/FormInputPassword";

    export default {
        name: "PurchasersUpdateModal",
        components: {FormInputPassword, Button, FormInputSelect, FormGroupTwo, FormInputText, Form, ModalContainer},
        props: {
            purchaser_id: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                original: null,
                purchaser: {
                    name: null,
                    phone: null,
                },
                is_saving: false,
                is_loading_original: false,
            }
        },
        validations: {
            purchaser: {
                name: {required},
                phone: {required},
            }
        },
        methods: {
            close(status) {
                this.$modal.hide('purchasers-update-modal', status);
            },
            save() {
                this.$v.purchaser.$touch();
                if (this.$v.purchaser.$anyError || this.is_saving)
                    return;

                this.is_saving = true;

                let payload = {}

                if (this.original.attributes.name !== this.$v.purchaser.name.$model)
                    payload.name = this.$v.purchaser.name.$model;

                if (this.original.attributes.phone !== this.$v.purchaser.phone.$model)
                    payload.phone = this.$v.purchaser.phone.$model;

                this.$axios.patch(`purchasers/${this.purchaser_id}`, payload).then(({data}) => {
                    this.$notify({
                        text: this.$t('purchasers.success_updated'),
                        type: 'success',
                    });

                    this.is_saving = false;
                    this.close(true);
                }).catch(e => {
                    this.is_saving = false;

                    this.$notify({
                        title: this.$t('error'),
                        text: this.$larerror(e.response.data.errors, this.$t('purchasers.error_update')),
                        type: 'error',
                    });
                });
            },
            populate() {
                if (!this.original || !this.purchaser)
                    return;

                this.$v.purchaser.name.$model = this.original.attributes.name;
                this.$v.purchaser.phone.$model = this.original.attributes.phone;
            },
            async retrieveOriginalPurchaser() {
                this.is_loading_original = true;

                await this.$axios.get(`purchasers/${this.purchaser_id}`)
                    .then(({data}) => {
                        this.original = data.data;
                        this.is_loading_original = false;
                    })
                    .catch(e => {
                        this.is_loading_original = false;

                        this.$notify({
                            title: this.$t('error'),
                            text: this.$larerror(e.response.data, this.$t('purchasers.error_retrieve')),
                            type: 'error',
                        });
                    });
            },
        },
        async mounted() {
            await this.retrieveOriginalPurchaser();
            this.populate();
        }
    }
</script>
